import {groupByUniqueKey} from '@benchling/js-utils';

import {
  ProcessGraphBuilderOutputNode,
  ProcessGraphBuilderRootNode,
  ProcessGraphBuilderTaskNode,
  SchemaMapperConfigWithMapperData,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';
import {getSchemaIdMappingToNode} from 'processes/graph-builder-processes/validation/ProcessGraphGetters';

export default function getSchemaOfItemsBeingRouted(
  upstreamNode: ProcessGraphBuilderTaskNode | ProcessGraphBuilderRootNode,
  downstreamNodes: Array<ProcessGraphBuilderTaskNode | ProcessGraphBuilderOutputNode>,
  schemaMapperConfigs: Array<SchemaMapperConfigWithMapperData>
): string | null {
  const mapperConfigByClientId = groupByUniqueKey(schemaMapperConfigs, ({clientId}) => clientId);

  const sourceSchemaIds = downstreamNodes.map((node) =>
    getSchemaIdMappingToNode(node, upstreamNode, schemaMapperConfigs, mapperConfigByClientId)
  );
  if (sourceSchemaIds.includes(null)) {
    return null;
  }
  if (new Set(sourceSchemaIds).size !== 1) {
    return null;
  }
  return sourceSchemaIds[0];
}
